import { api } from '@config/api';
import type { ResultadoRetentativa, ResumoEscritas } from '../types/EscritasAxiis';

export const escritasAxiisService = {
  resumo: (id: string) =>
    api.get<ResumoEscritas>(`/campanhas/${id}/escritas-axiis/resumo`).then((r) => r.data),
  retentar: (id: string) =>
    api
      .post<ResultadoRetentativa>(`/campanhas/${id}/escritas-axiis/retentativas`, {})
      .then((r) => r.data),
};
